"use strict";

define('libs/storage.helper',['underscore', 'backbone', 'cookie'], function (_, Backbone) {
  var DEFAULT_KEY = 'global-storage';
  var StorageHelper = Backbone.Model.extend({
    options: {
      expires: 365
    },
    constructor: function constructor(options) {
      this.requesting = 0;
      this.options = _.extend({}, _.result(this, 'options'), _.omit(options, 'key'));
      this.attributes = {};
      this.changed = {};
      this.key = (options || {}).key || DEFAULT_KEY;
      this.once('load', function () {
        this.on('change', this.save, this);
      }, this);
    },
    load: function load(defaults) {
      try {
        this.set(_.extend({}, defaults, JSON.parse(this.fetchData(this.key))));
      } catch (e) {
        this.set(_.extend({}, defaults));
      }
      this.trigger('load');
      return this;
    },
    save: function save() {
      try {
        this.serializeData(this.key, JSON.stringify(this), this.options);
      } catch (e) {}
      this.trigger('save');
      return this;
    },
    fetchData: function fetchData(key) {
      return $.cookie(key);
    },
    serializeData: function serializeData(key, data, options) {
      $.cookie(key, data, options);
    }
  });
  return StorageHelper;
});

